var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex items-center justify-start sm:flex-col sm:justify-center sm:space-y-4"},[_vm._t("icon",null,{"height":_vm.height,"width":_vm.width}),_c('div',{staticClass:"ml-4 text-secondary text-base font-medium uppercase sm:ml-0 sm:text-center sm:text-xl"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }